<template>
    <gcmcn-layout
        title="Settings"
        custom-class="entities-view"
    >
        <div style="margin: 30px;">
            <el-tabs
                v-if="$store.getters.userIsSuperUser"
                class="gcmcn-tabs"
                v-model="activeName"
            >
                <el-tab-pane label="Latency" name="latencies">
                    <latency></latency>
                </el-tab-pane>
                <el-tab-pane label="Manage admin user" name="users">
                    <manage-admin-users></manage-admin-users>
                </el-tab-pane>
            </el-tabs>
            <div v-else-if="$store.getters.userIsAtLeastAdmin">
                <h1>Latency</h1>
                <latency></latency>
            </div>
            <div v-else>
                <h4>You are not allowed to access the settings page</h4>
            </div>
        </div>
    </gcmcn-layout>
</template>

<script>
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import Latency from './Latency/index.vue';
import ManageAdminUsers from './Users/index.vue';
export default {

    components: {
        GcmcnLayout,
        Latency,
        ManageAdminUsers,
    },

    props: {
    },

    data (){
        return {
            activeName: 'latencies', // Can be 'latencies', 'users'
        };
    },

    computed: {

    },

    watch: {
    },

    mounted (){
    },

    methods: {
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/Setting/index.vue